export const NIGHTS_GET_ALL_EXTRAS_PRICE = "NIGHTS_GET_ALL_EXTRAS_PRICE";
export const NIGHTS_GET_BAGS_PRICE_FOR_ALL_PASSENGERS =
  "NIGHTS_GET_BAGS_PRICE_FOR_ALL_PASSENGERS";
export const NIGHTS_GET_EXTRA_BY_ID = "NIGHTS_GET_EXTRA_BY_ID";
export const NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY =
  "NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY";
export const NIGHTS_GET_EXTRA_UNIT_PRICE = "NIGHTS_GET_EXTRA_UNIT_PRICE";
export const NIGHTS_GET_PASSENGERS_COUNT = "NIGHTS_GET_PASSENGERS_COUNT";

export const NIGHTS_GET_QUERY_PARAMS = "NIGHTS_GET_QUERY_PARAMS";
export const NIGHTS_GET_TOTAL_PRICE = "NIGHTS_GET_TOTAL_PRICE";
export const NIGHTS_GET_SELECTED_EXTRA_BY_ID =
  "NIGHTS_GET_SELECTED_EXTRA_BY_ID";
export const GET_NIGHTS_DISCOUNT_CODE = "GET_NIGHTS_DISCOUNT_CODE";
export const GET_NIGHTS_DISCOUNT_CODE_IS_APPLICABLE =
  "GET_NIGHTS_DISCOUNT_CODE_IS_APPLICABLE";
export const GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT =
  "GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT";
export const GET_NIGHTS_DISCOUNT = "GET_NIGHTS_DISCOUNT";

export const NIGHTS_GET_HOTEL_PRICE = "NIGHTS_GET_HOTEL_PRICE";
export const NIGHTS_GET_HOTEL_RATE_COMMENTS = "NIGHTS_GET_HOTEL_RATE_COMMENTS";
export const NIGHTS_GET_RATE_PRICE = "NIGHTS_GET_RATE_PRICE";
export const NIGHTS_GET_SELECTED_HOTEL_PRICE =
  "NIGHTS_GET_SELECTED_HOTEL_PRICE";
export const NIGHTS_GET_NIGHTS = "NIGHTS_GET_NIGHTS";
export const NIGHTS_GET_MIN_ROOMS = "NIGHTS_GET_MIN_ROOMS";
export const NIGHTS_GET_BAGS_SUMMARY_INFO = "NIGHTS_GET_BAGS_SUMMARY_INFO";
export const NIGHTS_GET_CHEAPEST_FLIGHT_TO_DESTINATION =
  "NIGHTS_GET_CHEAPEST_FLIGHT_TO_DESTINATION";
export const NIGHTS_GET_PACK_HOTELS = "NIGHTS_GET_PACK_HOTELS";
export const NIGHTS_GET_SELECTED_CATEGORY = "NIGHTS_GET_SELECTED_CATEGORY";
export const NIGHTS_GET_ITINERARY = "NIGHTS_GET_ITINERARY";
export const GET_RESERVATION_ID ="GET_RESERVATION_ID";
export const NIGHTS_GET_TOTAL_PRICE_PACK_HOTELS = 'NIGHTS_GET_TOTAL_PRICE_PACK_HOTELS';
export const NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY = 'NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY';
export const NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD = 'NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD';
export const GET_PACK_FLIGHTS ="GET_PACK_FLIGHTS";
export const GET_TYPE_PACK_DATES = "GET_TYPE_PACK_DATES";
export const NIGHTS_GET_IS_PACK_FLIGHT = "NIGHTS_GET_IS_PACK_FLIGHT";
export const NIGHTS_GET_LUXURY_EXTRA = "NIGHTS_GET_LUXURY_EXTRA";
export const NIGHTS_GET_INTERN_FLIGHTS = "NIGHTS_GET_INTERN_FLIGHTS";
export const LOADING_PACK_WIZARD = "LOADING_PACK_WIZARD";
export const GET_FLIGHT_SELECTOR = "GET_FLIGHT_SELECTOR";
export const GET_DESTINATION_CARDS = "GET_DESTINATION_CARDS";
export const GET_EXTRA_NO_PROMO_PRICE = "GET_EXTRA_NO_PROMO_PRICE";
